import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CategoryPage from "@/pages/CategoryPage";
import StateMunicipalities from "@/pages/StateMunicipalities";
import PendingApprovals from "@/pages/PendingApprovals";
import RfidIntegration from "@/pages/RfidIntegration";
import GpsIntegration from "@/pages/GpsIntegration";
import RoadSweeping from "@/pages/RoadSweeping";
import LegacyWaste from "@/pages/LegacyWaste";
import MhariSadak from "@/pages/MhariSadak";
import SwacchataApp from "@/pages/SwacchataApp";
import JanSamwad from "@/pages/JanSamwad";
import SbmFund from "@/pages/SbmFund";
import PropertyTax from "@/pages/PropertyTax";
import OwnFund from "@/pages/OwnFund";
import RtsTimelines from "@/pages/RtsTimelines";
import AreaSabha from "@/pages/AreaSabha";
import BestPractices from "@/pages/BestPractices";
import MonitoringOverview from "@/pages/MonitoringOverview";
import Leaderboard from "@/pages/Leaderboard";
import Users from "@/pages/Users";
import Roles from "@/pages/Roles";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

function Protected({ children, superOnly }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="flex h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (superOnly && user.role !== "super_admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/category/:key" element={<Protected><CategoryPage /></Protected>} />
            <Route path="/municipalities" element={<Protected><StateMunicipalities /></Protected>} />
            <Route path="/pending" element={<Protected><PendingApprovals /></Protected>} />
            <Route path="/rfid" element={<Protected><RfidIntegration /></Protected>} />
            <Route path="/gps" element={<Protected><GpsIntegration /></Protected>} />
            <Route path="/road-sweeping" element={<Protected><RoadSweeping /></Protected>} />
            <Route path="/legacy-waste" element={<Protected><LegacyWaste /></Protected>} />
            <Route path="/mhari-sadak" element={<Protected><MhariSadak /></Protected>} />
            <Route path="/swacchata-app" element={<Protected><SwacchataApp /></Protected>} />
            <Route path="/jan-samwad" element={<Protected><JanSamwad /></Protected>} />
            <Route path="/sbm-fund" element={<Protected><SbmFund /></Protected>} />
            <Route path="/property-tax" element={<Protected><PropertyTax /></Protected>} />
            <Route path="/own-fund" element={<Protected><OwnFund /></Protected>} />
            <Route path="/rts-timelines" element={<Protected><RtsTimelines /></Protected>} />
            <Route path="/area-sabha" element={<Protected><AreaSabha /></Protected>} />
            <Route path="/best-practices" element={<Protected><BestPractices /></Protected>} />
            <Route path="/monitoring-overview" element={<Protected><MonitoringOverview /></Protected>} />
            <Route path="/leaderboard" element={<Protected><Leaderboard /></Protected>} />
            <Route path="/users" element={<Protected superOnly><Users /></Protected>} />
            <Route path="/roles" element={<Protected superOnly><Roles /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
